<template>
    <div id="app"  :class="projectTheme === 'theme-purple'? 'theme-purple' : 'theme-default'">
        <div class="mala-content clearfix" :class="{'mala-knowlege tranPathBg':$route.meta.keepAlive===5,'mala-knowlege eventMap':$route.meta.keepAlive===1}">
            <!-- 头部导航 -->
            <Topmenu v-if="$route.meta.topShow"></Topmenu>
            <div class="content clearfix" ref="child" :class="!$route.meta.topShow ? '' : 'w12'">
                <router-view></router-view>
            </div>
        </div>
        <!-- 提示弹框 -->
        <Dialog ref="tipsModal" type="alert">
            <div slot="mdBox">
                <p class="ac" v-html="tipsHtml"></p>
            </div>
        </Dialog>
        <!-- loading -->
        <div class="loadBox ac" v-show="showLoad">
            <div class="loadCont">
                <img src="../static/images/loading1.gif"/>
                <p>{{loadHtml}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Dialog from '@/components/dialog'
import Topmenu from '@/components/topMenu'
export default {
  components: {Topmenu,Dialog},
  name: 'App',
  data(){
        return{
            projectTheme: 'theme-purple',
            realmName:'',//域名
            tipsHtml:'',//提示语句
            userName:'',//用户昵称

            timeSection:'365',
            isSignin:false,
            showLoad:false,
            loadHtml:'正在加载...',
            hotKey:[]
        }
    },
    mounted() {
		let that = this;
        //that.$nextTick(()=> {
            //验证登录信息
            let host = window.location.host;
            if(that.$route.meta.title){
                document.title = that.$route.meta.title;
            }

            // 获取cookie setview
            let setview = this.getCookie("setview");
            console.log(setview)
            // 如果setview < 0   则设置为紫色主题
            if (setview < 0) {
              that.projectTheme = "theme-purple"
            } else {
              that.projectTheme = "theme-default"
            }
            // if(!this.$route.query.api_secret){  //为了放开详情页，有这个参数不进入热点参考
            //     if(host === 'hot.nybkz.com'){//线上
            //         let cooke = document.cookie.indexOf("_gsdataCL");
            //         if(cooke != -1){
            //             that.isSignin = true;
            //         }else{
            //             if(that.$route.meta.requireAuth){
            //                 that.showLoad = false;
            //                 //that.$router.push({ path:'/login'});
            //                 window.location.href="https://u1.nybkz.com/member/login?url=http://"+host+"/";
            //             }
            //         }
            //     }
            //     that.hotKeyWords();
            // }
       // })
    },
    methods:{
      getCookie(name) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
      },
        loadModal(isShow,txt){
            let that = this;
            if(txt!=''){
                that.loadHtml = txt;
            }
            that.showLoad = isShow;
        },
        // alert提示
        alertTips (text) {
            this.tipsHtml = text;
            this.$refs.tipsModal.showMaskFun();
        },
        // code判断
        returnCode (data,callback) {
            let code = data.code;
            if(code === 10000){
                callback();
            }else{
                if(code === 10003){//未登录
                    //that.$router.push({ path:'/login'});
                    window.location.href= data.data;
                    // let host = window.location.host;
                    // window.location.href="https://u1.nybkz.com/member/login?url=http://"+host+"/";
                }else{
                    if(data.msg != undefined){
                        this.$utils.alertText(data.msg);
                    }
                }
                this.showLoad = false;
                this.$refs.child.isDisable = false;
            }
        }
    }
}
</script>

<style>
  @import "./style/animate.css";
  @import "./style/base.css";
  @import "./style/style.css";

  /* theme-purple header样式 */
  .theme-purple .headerWrap{box-shadow: 0 0 2px rgba(127,51,214,0.5) !important;}
  .theme-purple .headerWrap .logout{color: #fff !important;}
  .theme-purple .headerWrap .header{background-color: #7F33D6 !important;}
  .theme-purple .headerWrap .topLi{color:#fff !important;}
  .theme-purple .headerWrap .topLi+.topLi:before{background-color:rgba(255,255,255,.4) !important;}
  .theme-purple .headerWrap .nav-menu li a{color:#fff !important;}
  .theme-purple .headerWrap .nav-menu li a:hover{color:#fff !important;text-decoration:none !important;}
  .theme-purple .headerWrap .nav-menu li .router-link-active:not(.active-none){border-bottom-color:#fff !important;color: #fff !important;}
  .theme-purple .headerWrap .search-btn{background-color:#7F33D6 !important;}
</style>



// WEBPACK FOOTER //
// src/App.vue